import { combineReducers } from '@reduxjs/toolkit';
import createKitDeviceReducer from './create-kit-device';
import deleteKitDeviceReducer from './delete-kit-device';

const kitDeviceReducer = combineReducers({
  createKitDevice: createKitDeviceReducer,
  deleteKitDevice: deleteKitDeviceReducer
});

export default kitDeviceReducer;